import "../components/wordpress/wp-gallery/wp-gallery"

import "./lazyload/lazyload-init"

import "../components/wordpress/aside/aside"
import "../components/wordpress/entry-content"

import "../components/scroll-up/scroll-up"
import "../components/forms/field-base"
import "../components/form-control/select-input/select-input"
import "../components/input-info/input-info"

import "../components/sections/feedback-slide-section/feedback-slide-section"
import "../components/sections/intro-slide-section/intro-slide-section"
import "../components/forms/intro-slide-form/intro-slide-form"
import "../components/items/faq-item/faq-item"
import "../components/main-header/main-header"
import "../components/sections/intro-section/intro-section"
import "../components/sections/download-section/download-section"
import "../components/sections/products-section/products-section"
import "../components/sections/text-and-media-section/text-and-media-section"
import "../components/sections/form-init-section/form-init-section"


async function loadFancybox() {
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("./fancybox/fancybox");
  }
}
loadFancybox();

async function loadFormValidation() {
  if (document.querySelectorAll('[data-validate="jquery"]').length) {
    await import("./form-validation");
  }
}

loadFormValidation();
